import {
    Typography, Box, Tooltip
    //Button, MenuItem, InputLabel,Select, FormControl, FormHelperText
  } from '@mui/material';


import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import {usePlayContext} from '../utils/PlayContext'
import HomeIcon from '@mui/icons-material/Home';
import {   Link as RouterLink  } from "react-router-dom"

const PageTitle=()=>
{
  const {appTitle,} = usePlayContext()
  
    const links = Array.isArray(appTitle)? appTitle: Array(1).fill(appTitle)
    return (
    <>
        
      <Breadcrumbs  sx={{pl:{xs:1, sm:2}, borderBottom:1, borderColor:'black'}}>
          <Tooltip title='Home Page'>
          <Link underline="hover" component={RouterLink} to={'/'}>
              <HomeIcon color='action'/>
          </Link>
          </Tooltip>
       
      {
       
          
          links.map( (t, i)=>
            (
              <Link underline="hover" key={t} 
                  color="inherit" aria-current={i==links.length-1? 'page':''}>
                {t}
                </Link>
            ))
      
      
              
      }
                
        
    </Breadcrumbs>
    </>  
    );

}

export default PageTitle;